import * as React from 'react';

import './App.css';
import { Payment } from './checkout/Payment';
import { Settings }  from './settings/Settings';

export interface AffiniOptions{
  index: number;
  route: string;
  publicKey: string;
  data?: any
}

class App extends React.Component<AffiniOptions, any> {

  public render() {
    if(this.props.route == 'Settings'){
      return <Settings {...this.props.data}/>
    }

    return <div>
      <Payment {...this.props.data} publicKey={this.props.publicKey} index={this.props.index}/>
    </div>;
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.tsx